import {initMainNavigationHandler} from './Functions/MainNavigationHandler';
import {initFormSubmitHandler} from './Functions/FormSubmitHandler';
import {domReady} from './Functions/DomReady';
import {initBreakpointCheckerTabelement} from './Functions/Slider/TabelementSlider';
import {loginOverlay} from './Functions/LoginOverlay/LoginOverlay';
import {internshipOverlay} from './Functions/InternshipOverlay/InternshipOverlay';
import {selectJobGeneratorCards} from './Functions/TabElement';

domReady(() => {
  initMainNavigationHandler();
  initFormSubmitHandler();
  initBreakpointCheckerTabelement();
  loginOverlay();
  internshipOverlay();
  selectJobGeneratorCards();

  if (document.getElementsByClassName('js-imageGallery').length) {
    import(/* webpackChunkName: "ImageGalleryController" */ './Controller/ImageGalleryController').then(module => {
      new module.ImageGalleryController();
    });
  }

  if (document.getElementsByClassName('js-pageNav').length) {
    import(/* webpackChunkName: "PageNavigationController" */ './Controller/PageNavigationController').then(module => {
      new module.PageNavigationController();
    });
  }

  if (document.getElementsByClassName('js-videoWrapper').length) {
    import(/* webpackChunkName: "VideoOverlayController" */ './Controller/VideoOverlayController').then(module => {
      new module.VideoOverlayController();
    });
  }

  if (document.getElementsByClassName('js-select').length) {
    import(/* webpackChunkName: "SlimSelectController" */ './Controller/SlimSelectController').then(module => {
      new module.SlimSelectController();
    });
  }

  if (document.getElementsByClassName('js-searchFilters').length) {
    import(/* webpackChunkName: "SearchFiltersController" */ './Controller/SearchFiltersController').then(module => {
      new module.SearchFiltersController();
    });
  }

  if (document.getElementsByClassName('js-addInternshipForm').length) {
    import(/* webpackChunkName: "InternshipFormController" */ './Controller/InternshipFormController').then(module => {
      new module.InternshipFormController();
    });
  }

  if (document.getElementsByClassName('js-newsletter').length) {
    import(/* webpackChunkName: "FooterNewsletterController" */ './Controller/FooterNewsletterController').then(module => {
      new module.FooterNewsletterController();
    });
  }
});
